<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'profile.change_password' | translate}}</h4>
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div id="changePass">
    <form class="w-100" [formGroup]="changePasswordForm" (ngSubmit)="changeTempPassword()">
        <div class="row justify-content-center">
            <div class="col-12 pt-2 mw-351">
                <div class="form form-group w-100">
                    <label for="password" class="change-pass-label">{{'password.new_password' | translate}}<span class="error">*</span></label>
                    <input id="password" type="password" formControlName="password" class="form-control input-creds"
                        [ngClass]="{ 'is-valid': password['valid'], 'is-invalid': password['invalid'] }" />
                    <ng-container *ngIf="changePasswordForm.get('password').invalid || (changePasswordForm.get('password').touched)">
                        <div *ngIf="password['errors']&&password['errors']['required']" class="text-danger">
                            {{'general.required_field' | translate}}
                        </div>
                        <div *ngIf="password['errors']&&password['errors']['pattern']" class="text-danger">
                            {{'password.pass_pattern' | translate}}
                        </div>
                        <div *ngIf="password['errors']&&password['errors']['minlength']" class="text-danger">
                            {{'password.pass_length' | translate}}
                        </div>
                    </ng-container>
                </div>
                <div class="form form-group w-100 text-left">
                    <label for="confirmPassword" class="change-pass-label">{{'password.confirm_pass' | translate}}<span class="error">*</span></label>
                    <input type="password" formControlName="confirmPassword" class="form-control input-creds" id="confirmPassword"
                        [ngClass]="{ 'is-valid': confirmPassword['valid'] && (changePasswordForm['errors']==null),
                        'is-invalid': confirmPassword['invalid'] || ((confirmPassword['touched'] || formSubmitted) && (changePasswordForm['errors']&&changePasswordForm['errors']['passwordsDontMatch'])) }" />

                    <ng-container *ngIf="changePasswordForm.get('confirmPassword').invalid || (changePasswordForm.get('confirmPassword').touched)">
                        <div *ngIf="confirmPassword['errors']&&confirmPassword['errors']['required']" class="text-danger">
                            {{'general.required_field' | translate}}
                        </div>
                        <div *ngIf="(confirmPassword['touched'] || formSubmitted) && ((changePasswordForm['errors']&&changePasswordForm['errors']['passwordsDontMatch']))"
                            class="text-danger">
                            {{'password.pass_mismatch' | translate}}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <hr class="hr-m">
        <div class="row">
            <div class="col-12 text-right">
                <button type="button" class="btn btn-red btn-h-red mr-2" (click)="activeModal.close()">
                    {{'general.cancel' | translate}}
                </button>
                <button type="submit" id="submit" title="{{'register.validate' | translate}}"
                        class="btn btn-alertia btn-green btn-h-green btn-dis-green">
                    {{'register.validate' | translate}}
                </button>
            </div>
        </div>
        <div id="password_error" class="error text-center mt-2"></div>            
    </form>
</div>
